// extracted by mini-css-extract-plugin
module.exports = {"lomSelect":"Lom_lomSelect__n2hXj","center":"Lom_center__3oTgO"};